module.exports = __webpack_public_path__ + "static/media/verify-otp.e93f0c52.svg";